import styled from 'styled-components';
import Input from '../Input';
import Icon from '../Icon';
import { ScrollBarStyle } from '../ScrollBars/StyledComponents';
import { StyledButton as Button } from '../Button';

const darkGrey = '#444';
const blue = '#ecf2f9';

export const Wrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const ScrollWrapper = styled.div`
  position: fixed;

  ${props =>
    props.showOpenStyles &&
    `
    padding: 2px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.4);
    border-radius: 5px;
    z-index: 10000;
    background: #fff;
    overflow: hidden;
  `}
`;

export const ParentWrapper = styled.ul`
  max-height: 390px;
  margin: 0;
  overflow: auto;
  padding: 15px 0;
  ${ScrollBarStyle}

  ${props =>
    props.IEProps.showLessOptions &&
    `
      @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        max-height: 200px;
      }
    `}
`;

export const caretIfHasChildren = props => {
  if (props.hasChildren) {
    return `
      &:before{
        border: none;
        content: '\\f105';
        font-family: "Font Awesome 5 Pro";
        font-weight: 900;
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        width: 0;
        transition: transform .3s ease;
        opacity: 1;
      }
    `;
  }
  return '';
};

const itemStyle = `
  background: #fff;
  padding: 10px 50px 10px 20px;
  position: relative;
  color: ${darkGrey};
  transition: background .3s ease;
  white-space: nowrap;

  &:hover{
    background: ${blue}
  }
`;

export const ParentItem = styled.li`
  ${itemStyle}
  ${caretIfHasChildren}
  cursor: pointer;
`;

export const ChildrenWrapper = styled.ul`
  background: #fff;
  border-radius: 5px;
  overflow: auto;
  margin: 0;
  opacity: 0;
  padding: 15px 0;
  position: fixed;
  max-height: 390px;
  z-index: 99999;

  ${props =>
    props.isOpen &&
    `
    opacity: 1;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.4);
    border: 1px solid rgba(0, 0, 0, 0.2);
  `}
`;

export const ChildrenItem = styled.li`
  cursor: pointer;
  ${itemStyle}
`;

export const NonInteractiveItem = styled.li`
  background: #fff;
  padding: 0 20px 15px 20px;
  position: relative;
  color: ${darkGrey};
  white-space: nowrap;
`;

export const GroupItem = styled(NonInteractiveItem)`
  padding: 10px 50px 10px 15px;
  font-weight: 600;
`;

export const SearchInput = styled(Input).attrs({
  appearance: 'rounded',
  size: 'small',
  prependIcon: 'fa fa-search',
})`
  width: 100%;

  ${Input.StyledInput} {
    background: rgba(242, 239, 239, 0.34);
  }

  ${Input.PrependedIcon} {
    color: #d9d7d7;
  }
`;

export const CheckIcon = styled(Icon).attrs({
  className: 'fa fa-check-circle',
})`
  color: #0078d4;
  position: absolute;
  right: ${props => (props.hasCaret ? '2em' : '1em')};
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.2em;
`;

export const FilterWrapper = styled(NonInteractiveItem)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  text-transform: none;
  border-top: 1px solid #ededed;
  font-size: 16px;
  line-height: 1.2;
  padding: 12px 20px 15px 20px;
  margin: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  &:before {
  }
`;

export const FilterWrapperGhost = styled(NonInteractiveItem)`
  font-size: 16px;
  line-height: 1.2;
  padding: 12px 0 15px 0;
  &:after {
    content: '\xa0';
  }
`;

export const ClearButton = styled(Button.Link)`
  color: #4c91e2;
`;

export const ItemIcon = styled(Icon)`
  margin-right: 10px;
`;
